import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import App from "./App";
import "../src/styles/index.scss";
import NotAuthorizedPage from "./pages/NotAuthroized.pages";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./redux/store";
import { useSelector } from "react-redux";
import FBLiveProductListingPage from "./pages/FBLiveProductListing.page";
import FBLiveProductPreviewsPage from "./pages/FBLiveProductPreviews.pages";

const AppWrapper = () => {
  const auth = useSelector((state) => state.auth);

  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route
          path="productListing/:id"
          element={<FBLiveProductListingPage />}
        />
        <Route path="productPreviews/:id" element={<FBLiveProductPreviewsPage />} />
        <Route path="/*" element={<NotAuthorizedPage />}></Route>
      </Routes>
    </BrowserRouter>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AppWrapper />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
